export enum FieldTypeEnum {
    string,
    integer,
    decimal,
    date,
    datetime,
    boolean,
    enum
}
